import {TopMenuView} from '../view/top_menu_view';
import {connect} from "react-redux";
import { setFullscreen, setTopMenuDropdownIsOpen, setTopMenuEntry } from "../actions/top_menu_actions";
import { RootState } from "../../../app/store"
import { Dispatch } from '@reduxjs/toolkit';

import { library } from '@fortawesome/fontawesome-svg-core';
import {fas} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
library.add(fas);

function mapStateToProps(state:RootState){
    return {
        user:state.LoginManager.model,
        leftmenuItems:[
            // ["", "Hide", <FontAwesomeIcon icon={["fas", "tachometer-alt"]}/>, ""],
            ["Return", "", <FontAwesomeIcon icon={["fas", "arrow-left"]}/>, ""],
            ["Home", "dashboard", <FontAwesomeIcon icon={["fas", "home"]}/>, ""],
           ],
        // rightmenuItems:[["Notification"], ["cart"], ["expand"],["settings", "test"], ["logout"]],
        rightmenuItems:[
            ["Notification", "", <FontAwesomeIcon icon={["fas", "bell"]}/>, 
                [
                    ["abcd","Attention",<FontAwesomeIcon icon={["fas", "exclamation-circle"]}/>],
                    ["abcd","Message",<FontAwesomeIcon icon={["fas", "envelope"]}/>],
                    ["abcd","Finished Scan",<FontAwesomeIcon icon={["fas", "flag-checkered"]}/>]
                ]
            ],
            // ["#", "", , ""],            
            // ["cart", "", <FontAwesomeIcon icon={["fas", "shopping-cart"]}/>, ""],
            // ["Fullscreen", "", <FontAwesomeIcon icon={["fas", "expand-arrows-alt"]}/>, ""],
            // ["#", "", , ""],
            ["settings", "", <FontAwesomeIcon icon={["fas", "user"]}/>,   //"cog"
            [
                ["/Users/"+state.LoginManager.model.id,state.LoginManager.model.username,<FontAwesomeIcon icon={["fas", "user"]}/>],
                // ["aassbcd","General",<FontAwesomeIcon icon={["fas", "laptop-code"]}/>]
            ]
            ],
            ["/login", "", <FontAwesomeIcon icon={["fas", "power-off"]}/>, ""],
            ],
        isDropdownOpen:state.topMenu.isDropdownOpen,
        isFullscreenEnabled:state.topMenu.isFullscreenEnabled,
    }
}

function bindDispatchToActions(dispatch:Dispatch<any>){
    return {
        onMenuItemClickedCb:(item:string) => {
            dispatch(setTopMenuDropdownIsOpen({isopen:true}));
            dispatch(setTopMenuEntry({nextentry:item}));
        },
        onSwitchFullscreen:(enable:boolean) =>
        {
            dispatch(setFullscreen({fullscreenenable:enable}));
            console.log(enable +"fullscreen")
        }
    }
}

const TopMenuViewContainer=connect(mapStateToProps, bindDispatchToActions)(TopMenuView);
export default TopMenuViewContainer;